var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Popover, PopoverBody, PopoverContent, PopoverTrigger, Portal, useDisclosure, useMultiStyleConfig, } from '@chakra-ui/react';
import { useSelect } from '../hooks';
import { Input } from '../Input';
import { defaultColorList } from './colors';
export const ColorPicker = (_a) => {
    var { options = defaultColorList, defaultValue, value, children, onChange } = _a, props = __rest(_a, ["options", "defaultValue", "value", "children", "onChange"]);
    const { optionList: colorList, selectedOption, isLoading, updateSelect, } = useSelect({
        value,
        defaultValue,
        options,
        onChange,
    });
    const { onOpen, onClose, isOpen } = useDisclosure();
    const onValueChange = (option) => {
        updateSelect(option);
        setTimeout(() => {
            onClose();
        }, 150);
    };
    const { w, width, size, variant } = props, extraProps = __rest(props, ["w", "width", "size", "variant"]);
    const swidth = width || w || '8rem';
    const styles = useMultiStyleConfig('ColorPicker', { size, variant });
    return (_jsxs(Popover, Object.assign({ placement: "bottom-start", returnFocusOnClose: false, isOpen: isOpen, onOpen: onOpen, onClose: onClose }, { children: [_jsx(PopoverTrigger, { children: _jsx(Input, Object.assign({ type: "button", cursor: "pointer", size: size, __css: styles.select, width: swidth, bg: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value, backgroundClip: "padding-box", border: "3px solid", borderColor: "blackAlpha.100", isLoading: isLoading }, extraProps)) }), _jsx(Portal, { children: _jsx(PopoverContent, Object.assign({ width: "auto", rootProps: { zIndex: 'popover' } }, { children: _jsx(PopoverBody, Object.assign({ px: "3", py: "2.5" }, { children: _jsx(Box, Object.assign({ display: "grid", gridAutoFlow: "column", gridTemplateRows: "repeat(4, minmax(0, 1fr))", gridGap: "10px" }, { children: colorList.map((color) => (_jsx(Box, { w: 6, h: 6, bg: color.value, borderRadius: "xs", cursor: "pointer", "aria-selected": color.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value), _hover: { boxShadow: size }, sx: {
                                    '&[aria-selected=true]': {
                                        border: '3px solid',
                                        borderColor: 'blackAlpha.100',
                                    },
                                }, onClick: () => onValueChange(color) }, color.value))) })) })) })) })] })));
};
ColorPicker.Option = Option;
export default ColorPicker;
